import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import PopupMenu from '../../../../components/PopupMenu';
import TableRow from '../../../../components/Table/TableRow';
import directoryIcon from '../../../../assets/images/directory-icon-light-gray.svg';
import addIcon from '../../../../assets/images/add-icon-gray.svg';
import TableHeader from '../../../../components/Table/TableHeader';
import dataModel from '../../../../models/DataModel';

import './TeamsTable.scss';
import LoadingDots from '../../../../components/LoadingDots';

export class TeamsTable extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      sortedType: this.props.sortField,
      sortAsc: this.props.ascending,
    };

  }

  componentDidUpdate(prevProps) {
    if (prevProps.accent != this.props.accent) {
      this.setState({ accent: this.props.accent });
    }
    else if (prevProps.filterCleared != this.props.filterCleared) {
      this.infiniteDone = false;
    }
  }

  handleScrolling() {
    const { teams } = this.props;
    const listRect = this.list.getBoundingClientRect();
    const scrollRect = this.scroller.getBoundingClientRect();
    if (!this.infiniteDone &&
      listRect.bottom <= scrollRect.bottom + 12 &&
      !this.scrollinProgress &&
      ((teams.teams && teams.teams.length < teams.totalRecords))) {
      this.scrollinProgress = true;
      this.setState({ loadingMore: true });

      if (this.props.getMoreUsers) {
        this.props.getMoreUsers(this.props.currentUser, (teams) => {
          if (teams.teams.length >= teams.totalRecords) {
            this.infiniteDone = true;
          }
          this.handledLoadMoreOnTransition = false;
          this.scrollinProgress = false;
          this.setState({ loadingMore: false });
        });
      }
    }
  }

  handleSort(type, direction) {
    if (type == this.state.sortedType && direction == 'up' && this.state.sortAsc) {
      this.setState({ sortedType: null, infiniteScroll: false });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null);
    }
    else if (type == this.state.sortedType && direction == 'down' && !this.state.sortAsc) {
      this.setState({ sortedType: null, infiniteScroll: false });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null);
    }
    else {
      this.props.handleSortChange(type, direction == 'up' ? true : false);
      this.infiniteDone = false;

      this.setState({
        sortedType: type,
        sortAsc: direction == 'up' ? true : false, infiniteScroll: false,
      });
    }
    switch (type) {
    case 'name':
      this.setState({ nameBusy: true });
      break;
    case 'lead_user':
      this.setState({ leadBusy: true });
      break;
    case 'projects_active':
      this.setState({ activeProjectsBusy: true });
      break;
    case 'members':
      this.setState({ numMembersBusy: true });
      break;
    case 'markets':
      this.setState({ marketsBusy: true });
      break;
    default:
      break;
    }
  }

  handleAddButtonClicked() {
    this.props.history.push('/directory');
  }

  handleSelectTeam(team) {
  }

  handleOptions(event, team) {
    const menu = this.createMoreMenu(event, team);
    this.setState({ menu, team });
  }

  createMoreMenu(event, team) {
    if (!this.props.permissions.canDeleteUser && !this.props.permissions.canEditUser) {
      return null;
    }
    const menuOptions = [];
    if (this.props.permissions.canEditUser || this.props.permissions.isSuperUser) {
      menuOptions.push({
        type: 'edit',
        name: 'Edit',
      });
    }
    if (this.props.permissions.canDeleteUser || this.props.permissions.isSuperUser) {
      menuOptions.push({
        type: 'delete',
        name: 'Delete',
      });
    }
    let rect = event.target.getBoundingClientRect();
    return (
      <PopupMenu
        left={rect.right - 256}
        top={rect.top - 40}
        width={256}
        menuOptions={menuOptions} size="smaller"
        menuId="teamMenu"
        popupOnHover={false}
        handleMenuSelection={this.handleMenuSelection}
        height={85}
        handleClickAway={this.handleCloseMenu}
      />
    );
  }

  handleCloseMenu() {
    this.setState({ menu: null, team: null });
  }

  handleDeleteTeam(team) {
    if (this.props.handleDeleteTeam) {
      this.props.handleDeleteTeam(team);
    }
  }

  handleMenuSelection(type) {
    const { team } = this.state;
    switch (type) {
    case 'delete':
      this.handleDeleteTeam(team);
      break;
    case 'edit':
      if (this.props.selectTeam) {
        this.props.selectTeam(team);
      }
      break;
    default:
      break;
    }
  }

  handleDeleteUser(team) {
    const message = 'Are you sure you want to remove this team?';
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      width: 300,
      height: 200,
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'Delete',
      handleOwnerOk: () => {
        this.doDeleteTeam(team);
      },
    });
  }

  doDeleteTeam(team) {
    dataModel.teamsDAO.deleteTeam(team);
  }

  handleCreateTeamRows() {
    let even = false;
    let rows;
    let actualTeams = this.props.teams.teams;
    
    if (actualTeams) {
      if (this.props.searchString) {
        actualTeams = actualTeams.filter(team => {
          return team.name.toLowerCase().indexOf(this.props.searchString.toLowerCase()) >= 0;
        });
      }

      rows = actualTeams.map(team => {
        even = !even;
        return (
          <TableRow
            key={team.id}
            selectedItem={team}
            even={even}
            select={this.handleSelectTeam}
            type={'team'}
            recordDescriptor={{ team: { markets: {}, lead_user: {}, users: {} } }}
            optionsHandler={this.handleOptions}
          />
        );
      });
    }
    return rows;
  }

  handleSetScroller(element) {
    if (element && !this.scroller) {
      this.scroller = element;
      this.scroller.addEventListener('scroll', this.handleScrolling);
    }
  }

  render() {
    let { accent } = this.props;
    let caretTypes = [
      { type: 'name', headerName: this.textMap.teamName.toUpperCase(), first: true },
      { type: 'lead_user', headerName: this.textMap.teamLead.toUpperCase() },
      { type: 'projects_active', headerName: this.textMap.projectsActive.toUpperCase() },
      { type: 'members', headerName: this.textMap.members.toUpperCase() },
      { type: 'markets', headerName: this.textMap.markets.toUpperCase() },
      { type: 'options', headerName: '' },
    ];

    let tableHeader = (
      <TableHeader
        key="team-table"
        accent={accent}
        caretTypes={caretTypes}
        reportType={'team'}
        sortDisabled={true}
      />
    );

    let teamRows = this.handleCreateTeamRows();

    let loadingMore = null;

    if (this.state.loadingMore || this.props.loadingTeams) {
      loadingMore = <div className="loading-more-indicator"><LoadingDots /></div>;
    }

    if (!this.props.inProgress && (!teamRows || teamRows.length == 0)) {
      if (this.props.filter || this.props.searchString) {
        teamRows = <div className="no-matches-indicator">No Results Found...</div>;
      }
      else if (!this.props.refresh) {
        tableHeader = null;
        let noTeamsText = <div className="no-teams">No teams found.</div>;
        if (this.props.permissions.canCreateUser) {
          noTeamsText = <div className="no-teams">There are no Users created yet for this company. <br />Select <img alt='button' className='add-button' src={addIcon} onClick={this.handleAddButtonClicked} /> to add a team.</div>;
        }
        teamRows = <div className='no-teams-container'>
          <img className='team-icon' src={directoryIcon} alt='icon' />
          {noTeamsText}
        </div>;
      }
    }

    return <div className={'team-table' + (this.props.filterDisplayed ? ' team-table__filter-enabled' : '')}>
      {tableHeader}
      <div className={'team-scroller infinite-scrolling'} ref={(element) => this.handleSetScroller(element)}>
        <div className='team-rows' ref={(element) => {
          this.list = element;
        }}>
          {teamRows}
          {loadingMore}
          {this.state.menu}
        </div>
      </div>
    </div>;
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  let accent = state.new_companies.currentCompany ? state.new_companies.currentCompany.accent_color : null;

  return {
    dataModel: dataModel,
    permissions: state.new_users.permissions,
    accent: accent,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,

  };
};

export default withRouter(connect(mapStateToProps)(TeamsTable));



// WEBPACK FOOTER //
// ./src/containers/Directory/Teams/TeamsTable/index.js